/* eslint-disable @typescript-eslint/no-unsafe-call */
import React from 'react';
import classNames from 'classnames';
import Avatar from 'common/components/Avatar';
import useLock from 'common/hooks/useLock';
import { useParams } from 'react-router-dom';
import ShowForPermissions from 'features/security/ShowForPermissions';
import styles from './AvatarWithMenu.module.scss';
import featureFlags from '../../helpers/featureFlags';

type Props = {
  showAvatarTooltip?: boolean;
  showInfoLockingUser?: boolean;
  contentThreadId: number;
  children: JSX.Element;
  fixedWidth: boolean;
};

const AvatarWithMenu: React.FC<Props> = ({
  showAvatarTooltip = true,
  showInfoLockingUser,
  contentThreadId,
  fixedWidth = false,
  children,
}: Props) => {
  const { name, isLocked } = useLock({ contentThreadId });
  const className = classNames(
    styles['avatar-with-menu'],
    fixedWidth ? styles['fixed-width'] : ''
  );
  return (
    <div className={className}>
      {isLocked && <Avatar name={name} showTooltip={showAvatarTooltip} />}
      {React.cloneElement(children, {
        showInfoLockingUser,
        lockingUserName: name,
        // eslint-disable-next-line
        isDisabled: isLocked || children.props.isDisabled,
      })}
    </div>
  );
};

const AvatarFeatureContainer: React.FC<Props> = ({ ...props }) => {
  const { projectId } = useParams<{ projectId?: string }>();
  return (
    <ShowForPermissions projectId={projectId} permissions={['Contribute']}>
      {featureFlags.isAutoSaveEnabled ? (
        <AvatarWithMenu {...props} />
      ) : (
        props.children
      )}
    </ShowForPermissions>
  );
};

export default AvatarFeatureContainer;
